<template>
  <div class="queridometro-page">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-content">
        <h1>🌟 Meu Queridômetro</h1>
        <p>Sinta-se visto todos os dias! Uma rede social emocional e divertida onde você envia <strong>emojos</strong> para seus amigos — de forma anônima e carinhosa.</p>
        <div class="cta-container">
          <a href="#" class="download-cta">
            <img src="../assets/google-play-badge.png" alt="Disponível no Google Play">
          </a>
        </div>
      </div>
      <div class="hero-media">
        <img src="../assets/logoqueridometro.png" alt="Ilustração do Queridômetro" class="hero-image">
      </div>
    </section>

    <!-- Funcionalidades -->
    <section class="core-features">
      <h2 class="section-title">🔑 Principais Funcionalidades</h2>
      <div class="feature-grid">
        <div class="feature-card">
          <div class="feature-icon">🧡</div>
          <h3>Meu Queridômetro</h3>
          <p>Veja todos os emojos anônimos que você recebeu nas últimas 24h. Eles desaparecem após esse período, criando uma timeline emocional sempre renovada.</p>
        </div>

        <div class="feature-card">
          <div class="feature-icon">👥</div>
          <h3>Rolar Amigos</h3>
          <p>Explore os perfis dos seus amigos, veja como está o Queridômetro deles e envie seu emojo do dia. Você pode mudar quantas vezes quiser!</p>
        </div>

        <div class="feature-card">
          <div class="feature-icon">🧍</div>
          <h3>Emojo de Status</h3>
          <p>Mostre como você está se sentindo hoje. Visível por 24h no seu perfil, como um clima emocional diário para seus amigos.</p>
        </div>

        <div class="feature-card">
          <div class="feature-icon">🔒</div>
          <h3>Perfis Públicos e Privados</h3>
          <p>Controle quem pode te adicionar. Perfis abertos permitem adições diretas; fechados exigem aprovação. Toda amizade é sempre recíproca.</p>
        </div>
      </div>
    </section>

    <!-- Objetivo do App -->
    <section class="app-goal">
      <h2 class="section-title">🎯 Nosso Propósito</h2>
      <p class="goal-text">
        Criar um espaço leve, onde as pessoas possam receber um feedback emocional espontâneo, sincero e anônimo. Queremos promover reflexões diárias e fortalecer laços sociais com mais afeto e empatia.
      </p>
    </section>

    <!-- Chamada Final -->
    <section class="final-cta">
      <div class="cta-content">
        <h2>Baixe e espalhe carinho!</h2>
        <p>Junte-se à comunidade que acredita que emoção também se compartilha 💛</p>
        <div class="download-badges">
          <a href="#" class="store-link">
            <img src="../assets/google-play-badge.png" alt="Google Play">
          </a>
        </div>
      </div>
    </section>
  
  
  
  
    <div class="privacy-section">
        <button @click="togglePrivacyPolicy" class="toggle-button">
          {{ showPrivacyPolicy ? 'Ocultar' : 'Mostrar' }} Política de Privacidade
          <span class="arrow" :class="{ 'up': showPrivacyPolicy }">▼</span>
        </button>
        
        <transition name="slide">
        <iframe 
                v-if="showPrivacyPolicy"
                :src="privacyPolicyContent"
                class="privacy-iframe"
                frameborder="0"
            ></iframe>
        </transition>
      </div>

      <div class="games-grid">
      <router-link to="/PadroesSeguracaMeuQueridometro" class="game-card">
          <h2>Padrões de segurança</h2>
          <p>Padrões de segurança infantil do Meu Queridometro</p>
        </router-link>
        </div>


  </div>

 

</template>

<script>
export default {
  name: 'QueridometroPage',
  data() {
    return {
      activeImage: 0,
      screenshots: [
        require('@/assets/screenshots/screen1.jpg'),
        require('@/assets/screenshots/screen2.jpg'),
        require('@/assets/screenshots/screen3.jpg')
        
      ],
      showPrivacyPolicy: false,
      privacyPolicyContent: `data:text/html;charset=utf-8,${encodeURIComponent(`
        <!DOCTYPE html>
        <html lang="pt-br">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Política de Privacidade - Meu Queridômetro</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
              max-width: 800px;
              margin: auto;
            }
            h1 {
              color: #333;
            }
            h2 {
              color: #555;
              margin-top: 20px;
            }
            p {
              line-height: 1.6;
            }
          </style>
        </head>
        <body>
          <h1>Política de Privacidade</h1>
          <p>No <strong>Meu Queridômetro</strong>, respeitamos sua privacidade. Esta política explica como coletamos, usamos e protegemos suas informações.</p>

          <h2>📋 Informações Coletadas</h2>
          <p>Coletamos apenas os dados essenciais para o funcionamento do aplicativo, como seu identificador de usuário, emojos enviados e recebidos, configurações de perfil e preferências.</p>

          <h2>🔐 Uso das Informações</h2>
          <p>As informações coletadas são utilizadas para oferecer uma experiência personalizada, garantir a segurança da plataforma e aprimorar os recursos disponíveis.</p>

          <h2>🤝 Compartilhamento com Terceiros</h2>
          <p><strong>Não compartilhamos, vendemos ou distribuímos seus dados pessoais para terceiros</strong>, exceto quando exigido por lei.</p>

          <h2>👶 Crianças e Adolescentes</h2>
          <p>O Meu Queridômetro pode ser utilizado por adolescentes, sempre prezando por uma comunicação leve e segura. Nenhum dado sensível é coletado sem consentimento.</p>

          <h2>🔗 Links Externos</h2>
          <p>Podemos conter links para sites de terceiros. Não nos responsabilizamos pelas políticas de privacidade de tais sites.</p>

          <h2>🛠 Atualizações</h2>
          <p>Esta política pode ser atualizada periodicamente. Sempre que houver mudanças, atualizaremos a data nesta página.</p>

          <h2>📧 Contato</h2>
          <p>Se tiver dúvidas, entre em contato com a gente pelo e-mail: <a href="mailto:contato@meuqueridometro.com">contato@meuqueridometro.com</a></p>
        </body>
        </html>

     `)}`

    }
  },
  methods: {
    nextImage() {
      this.activeImage = (this.activeImage + 1) % this.screenshots.length
    },
    prevImage() {
      this.activeImage = (this.activeImage - 1 + this.screenshots.length) % this.screenshots.length
    },
    togglePrivacyPolicy() {
        this.showPrivacyPolicy = !this.showPrivacyPolicy
      }
  }
}
</script>

<style scoped>
.queridometro-page {
  max-width: 1280px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.section-title {
  font-size: 2rem;
  color: #6A1B9A;
  text-align: center;
  margin: 3rem 0 2rem;
}

.hero-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: center;
  padding: 3rem 0;
}

.hero-content h1 {
  font-size: 2.8rem;
  color: #AD1457;
  margin-bottom: 1.2rem;
}

.hero-content p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #424242;
}

.hero-image {
  max-width: 100%;
  border-radius: 15px;
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2rem;
  padding: 2rem 0;
}

.feature-card {
  background: #F3E5F5;
  padding: 1.5rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.feature-icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.app-goal {
  background: #FCE4EC;
  padding: 3rem 1rem;
  border-radius: 15px;
  margin: 4rem 0;
  text-align: center;
}

.goal-text {
  font-size: 1.2rem;
  color: #6A1B9A;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.7;
}

.final-cta {
  text-align: center;
  padding: 3rem 0;
}

.final-cta h2 {
  font-size: 2rem;
  color: #AD1457;
  margin-bottom: 1rem;
}

.final-cta p {
  color: #616161;
  margin-bottom: 2rem;
}

.download-badges img {
  height: 60px;
}

@media (max-width: 768px) {
  .hero-section {
    grid-template-columns: 1fr;
    text-align: center;
  }
}


.privacy-section {
    margin-top: 30px;
    border-top: 1px solid #eee;
    padding-top: 20px;
  }
  
  .toggle-button {
    background: #4CAF50;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.3s;
  }
  
  .toggle-button:hover {
    background: #45a049;
  }
  
  .arrow {
    display: inline-block;
    transition: transform 0.3s;
    margin-left: 10px;
  }
  
  .arrow.up {
    transform: rotate(180deg);
  }
  
  .privacy-iframe {
    width: 100%;
    height: 500px;
    margin-top: 15px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .slide-enter-active, .slide-leave-active {
    transition: all 0.5s ease;
    max-height: 600px;
    overflow: hidden;
  }
  
  .slide-enter-from, .slide-leave-to {
    max-height: 0;
    opacity: 0;
  }


  .games-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 30px;
  }
  
  .game-card {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    text-decoration: none;
    color: #333;
    transition: transform 0.3s;
  }
  
  .game-card:hover {
    transform: translateY(-5px);
  }
  
  .game-card h2 {
    color: #4CAF50;
    margin-bottom: 10px;
  }


</style>
